// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
//import 'element-ui/lib/theme-chalk/index.css'
import '../theme/index.css'
import '@/assets/css/theme/02abfd/index.css';
import router from './router'
import store from './store'
import '@/assets/css/style.css'
import '@/assets/fontAwesome/css/font-awesome.min.css'
import '@/assets/css/CustomIcon/iconfont.css'
import { _ } from '@/helper'
import axios from 'axios'
import qs from 'qs'
import Vant from 'vant'
import 'vant/lib/index.css'
//import GridManager from 'gridmanager-vue'
import EncodeRule from '@/pages/SettingManage/EncodeRule'
import echarts from 'echarts'
import VueVideoPlayer from 'vue-video-player'

import 'video.js/dist/video-js.css'
import 'videojs-contrib-hls.js/src/videojs.hlsjs'
import 'videojs-contrib-hls'
import SuperMapCesium from 'vue-cesium-supermap'
import darkJson from '@/assets/dark'




// 使用video播放插件
Vue.use(VueVideoPlayer)

// 接入超图
Vue.use(SuperMapCesium, {
  cesiumPath: '/static/Cesium'
})

Vue.component('encodeRule', EncodeRule)
//Vue.use(GridManager)
Vue.use(Vant)
Vue.prototype.$axios = axios
Vue.prototype.axios = axios
Vue.prototype.$qs = qs
Vue.prototype.$echarts = echarts
Vue.prototype.$echarts.registerTheme('dark', darkJson)

Vue.prototype.$_ = _
Vue.use(ElementUI)
if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  document.title = '冰封开发平台入驻申请'
} else {
}
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  store.dispatch('setActiveTab', to.path)
  next()
})

Vue.directive('enterNumber', {
  inserted: function (el) {
    el.addEventListener('keypress', function (e) {
      e = e || window.event
      let charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode
      let re = /\d/
      if (
        !re.test(String.fromCharCode(charcode)) &&
        charcode > 9 &&
        !e.ctrlKey
      ) {
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.returnValue = false
        }
      }
    })
  }
})

// 为大屏组件添加mixins
let mixin = {
  data: function () {
    return {
      org_no: this.$route.query.org_no ? '' : this.$route.query.org_no,
      company_id: this.$route.query.company_id ? '' : this.$route.query.company_id
    }
  },
  methods: {
    initOptions: function () {

      let keys = Object.keys(this.propsOptions)
      let code = this.detail.customCode
      if (code !== '') {
        code = code.split('↵').join('').split(' ').join('')
        code = JSON.parse(code)
        this.propsOptions = Object.assign(this.propsOptions, code.style)
      } else {
        this.propsOptions = Object.assign(this.propsOptions, {})
      }
      for (let key of keys) {
        let val = this.detail[key]
        if (val) {
          this.propsOptions[key] = this.detail[key]
        }
      }
    }
  }
}

/* eslint-disable no-new */
new Vue({
  mixins: [mixin],
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js